/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { observable, when } from 'mobx';
import { translate } from 'react-i18next';

import CentralForm from 'components/CentralForm/CentralForm';
import { BoundTextField, ElectroButton } from 'components/ExtendedUiElements/customized';
import Loading from 'components/Loading/Loading';
import { inlineManualService } from 'services/ServiceRegistry';
import AuthenticationStore from 'stores/AuthenticationStore';
import { ENV } from 'config';

import styles from 'common-scss/formstyles.module.scss';

import TogglePassword from './TogglePassword';
import { LoggingIn } from './LoggingIn';

@translate()
@inject('authenticationStore', 'userStore', 'routing')
@observer
export default class LoginForm extends React.Component<*> {
  @observable loading: boolean = false;

  constructor(props: *) {
    super(props);

    const { authenticationStore, routing } = props;

    when(
      () => authenticationStore.authenticationState === 'authed',
      () => {
        routing.push('/');
      }
    );
  }

  async login(e): Promise<*> {
    e.preventDefault();

    try {
      window.external.AutoCompleteSaveForm(e.target.cloneNode(true));
    } catch (ex) {}

    const { authenticationStore, userStore, routing }: Object = this.props;

    this.loading = true;
    const result = await authenticationStore.login();
    if (result) {
      await userStore.getActiveUser();

      if (authenticationStore.authenticationState === 'authed') {
        await inlineManualService.initForUser(this.props.authenticationStore, this.props.userStore);
        routing.push('/');

        this.loading = false;
        return;
      }
    }

    this.loading = false;
    routing.push('/login-failed');
  }

  render() {
    const t: Function = this.props.t;
    const authenticationStore: AuthenticationStore = this.props.authenticationStore;

    if (
      ENV !== 'development' &&
      ENV !== 'uat' &&
      ENV !== 'qa' &&
      ENV !== 'demo' &&
      process.env.REACT_APP_MYER_DASHBOARD_PAGE
    ) {
      window.location.href = process.env.REACT_APP_MYER_DASHBOARD_PAGE;
      return <Loading />;
    }

    return this.loading ? (
      <LoggingIn />
    ) : (
      <CentralForm>
        <form onSubmit={this.login.bind(this)} method="post">
          <h1>{t('general:accounts.sign_in')}</h1>
          <BoundTextField
            model={authenticationStore}
            name="email"
            prop="email"
            floatingLabelText={t('general:labels.email_address')}
            hintText={t('general:placeholders.start_typing')}
          />
          <TogglePassword
            name="password"
            autoComplete="on"
            model={authenticationStore}
            prop="password"
            onChange={(e: SyntheticInputEvent<*>) => {
              authenticationStore.password = e.target.value;
            }}
            floatingLabelText={t('general:password')}
            hintText={t('general:placeholders.start_typing')}
            value={authenticationStore.password}
          />

          <div className={styles['button-group']}>
            <ElectroButton type="submit" label={t('general:actions.sign_in')} color="primary" />
            <hr />
            <h4>{t('general:accounts.reasons.forgotten_password')}</h4>
            <Link to="forgotten-password">{t('general:accounts.reset_password_request')}</Link>
            {ENV !== 'demo' && (
              <React.Fragment>
                <h4>{t('general:or')}</h4>
                <Link to="get-magic-link">{t('general:accounts.messages.magic_link_sign_in')}</Link>
                <h5>{t('general:accounts.reasons.dont_want_to_enter_password')}</h5>
                <p>{t('general:accounts.messages.get_magic_link_sent')}</p>
              </React.Fragment>
            )}
            <hr />
          </div>
        </form>
      </CentralForm>
    );
  }
}
